import {AfterViewInit, Compiler, Component, inject, Injector, ViewChild, ViewContainerRef} from '@angular/core';
import {DahSignAction, DahSignService} from "@dahlib/sign";
import {filter, map} from "rxjs/operators";
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";

import dayjs from 'dayjs';
import 'dayjs/locale/uk';

dayjs.locale('uk');

@Component({
    selector: 'dah-root',
    templateUrl: 'app.component.html',
    standalone: true,
    imports: [
        RouterOutlet
    ]
})
export class AppComponent implements AfterViewInit {
    @ViewChild('signWindowOutletContainer', {read: ViewContainerRef, static: true}) signWindowOutlet: ViewContainerRef;
    title = 'dah-cabinet';
    private viewport: HTMLElement | null;

    private sign = inject(DahSignService);
    private injector = inject(Injector);
    private compiler = inject(Compiler);
    private router = inject(Router);

    constructor() {
        if (window.location.href.indexOf('/app/') != -1) {
            window.location.href = window.location.href.replace('/app/', '/');
        }

        this.sign.loadDahSignModule$.subscribe((action: DahSignAction | void) => {
            this.loadDahSignModule(action);
        });

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(
                    () => {
                        if (this.router.url.indexOf('/greeting') != -1) {
                            this.viewport?.setAttribute('content', 'width=device-width, initial-scale=1');
                        } else {
                            this.viewport?.setAttribute('content', 'width=960, initial-scale=1');
                        }
                    }
                )
            ).subscribe();
    }

    loadDahSignModule(action?: DahSignAction | void) {
        if (this.sign.isLoading || this.sign.isLoaded) {
            return;
        }

        this.sign.isLoading = true;

        const injector = Injector.create({
            providers: [],
            parent: this.injector
        });

        import("../../projects/dahsign/src/lib/dah-sign.module").then(m => m.DahSignModule).then(dahsignModule => {
            this.compiler.compileModuleAsync(dahsignModule).then(ngModuleFactory => {
                const moduleRef = ngModuleFactory.create(injector);
                const factory = moduleRef.componentFactoryResolver.resolveComponentFactory(moduleRef.instance.getComponent());
                this.signWindowOutlet.createComponent(factory);
                this.sign.isLoaded = true;
                this.sign.isLoading = false;
                if (action) {
                    this.sign.run$.next(action);
                }
            });
        });
    }

    //eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngAfterViewInit(): void {
        // TODO: OS Check this
        // const body = document.querySelector('body');
        // this.viewport = document.getElementById('viewport');
        // if (body) {
        //     body.addEventListener('keypress', (event) => {
        //         if (event.key == 'Enter') {
        //             event.preventDefault();
        //         }
        //     });
        // }
    }
}
